<div id="elevaagendaedu">
  <eae-header-navigation [href]="urlListarFaturas" title="Detalhes da Fatura"></eae-header-navigation>
  <eae-fatura-detalhes [showTicket]="showTicket" [fatura]="fatura" [faturaDetalhada]="faturaDetalhada"></eae-fatura-detalhes>
  <eae-nav-fatura-detalhada 
    (onSetShowTicket)="setShowTicket($event)" 
    [showTicket]="showTicket" 
    [fatura]="fatura" 
    [faturaDetalhada]="faturaDetalhada"
  ></eae-nav-fatura-detalhada>
</div>
